import type { WasteMovementFormValues, WasteMovementStringFieldKey } from "../model/formValues";
import type { IWasteMovementEwcDefaultRule } from "@/customTypings/wasteMovement/WasteMovementDefaults";
import { applyEwcDefaultRule, type EwcRuleFieldState } from "./ewcDefaultRuleApplication";
import { mapPrefillToFormValues } from "./wasteMovementDefaultFieldMapping";

export type WasteMovementDefaultsBaseline = {
    values: WasteMovementFormValues;
    ewcState: EwcRuleFieldState;
};

/** Merges resolved site defaults into form values and returns the new baseline for resetForm. */
export function mergeWasteMovementSiteDefaultsIntoFormValues(
    current: WasteMovementFormValues,
    prefillValues: Record<string, string | null>,
    ewcRules: IWasteMovementEwcDefaultRule[],
    ewcState: EwcRuleFieldState
): WasteMovementDefaultsBaseline {
    const merged: WasteMovementFormValues = { ...current };
    const formPrefill = mapPrefillToFormValues(prefillValues);
    for (const [key, val] of Object.entries(formPrefill)) {
        if (val) {
            merged[key as WasteMovementStringFieldKey] = val;
        }
    }

    let nextEwcState = ewcState;
    const ewcId = formPrefill.regEwcCodeId ?? merged.regEwcCodeId;
    if (ewcId) {
        const ruleResult = applyEwcDefaultRule(ewcId, ewcRules, ewcState);
        nextEwcState = ruleResult.nextState;
        // EWC default rules only ever target single-value (string) fields.
        for (const [key, val] of Object.entries(ruleResult.updates)) {
            merged[key as WasteMovementStringFieldKey] = val as string;
        }
    }

    return { values: merged, ewcState: nextEwcState };
}
